import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import logo from "./logonav.png";
import {
  Drawer,
  Box,
  Button,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Divider,
} from "@mui/material";

export default function Navbar({ setAuth }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  let isAdmin = useSelector((state) => state.admin.value);
  let username = useSelector((state) => state.user.value);
  let isMember = useSelector((state) => state.member.value);
  var name = username.split("@")[0];

  const handleLogout = () => {
    sessionStorage.clear();
    setAuth(sessionStorage.getItem("accessToken"));
    navigate("/login");
  };
  if (location.pathname === "/login" || location.pathname === "/confirm") {
    return <></>;
  }
  return (
    <>
      <Drawer
        variant="permanent"
        anchor="left"
        sx={{
          "& .MuiDrawer-paper": {
            width: 180,
            background: "linear-gradient(to bottom right, #222831, #393E46)",
            color: "#EEEEEE",
            borderRight: `2px solid #B0B0B0`,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            position: "fixed",
            height: "100vh",
          },
        }}
      >
        <Box className="flex flex-col items-center py-4" sx={{ gap: 3 }}>
          <Link to="/accounts" style={{ textDecoration: "none" }}>
            <img
              src={logo}
              alt=":("
              className="w-20 h-auto"
              style={{
                transition: "transform 0.5s ease-in-out",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.transform = "scale(1.1)")
              }
              onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
            />
          </Link>
          <Divider sx={{ width: "80%", my: 0.5, backgroundColor: "#00ADB5" }} />
          {(isAdmin || isMember) && (
            <Button
              component={Link}
              to="/activity"
              className="w-full text-left px-3"
              sx={{
                color: "#EEEEEE",
                justifyContent: "flex-start",
                fontSize: "0.9rem",
                "&:hover": {
                  backgroundColor: "#393E46",
                  color: "#EEEEEE",
                },
                "&:hover .icon": {
                  color: "#EEEEEE",
                },
                fontFamily: "Poppins",
              }}
            >
              <Box
                className="icon"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  color: "#00ADB5",
                  marginRight: 1,
                }}
              >
                <LocalActivityIcon />
              </Box>
              User Activities
            </Button>
          )}
          {isAdmin && (
            <>
              <Button
                component={Link}
                to="/changerole"
                className="w-full text-left px-3"
                sx={{
                  color: "#EEEEEE",
                  justifyContent: "flex-start",
                  fontSize: "0.9rem",
                  padding: "10px",
                  "&:hover": {
                    backgroundColor: "#393E46",
                    color: "#EEEEEE",
                  },
                  "&:hover .icon": {
                    color: "#EEEEEE",
                  },
                  fontFamily: "Poppins",
                }}
              >
                <Box
                  className="icon"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "#00ADB5",
                    marginRight: 1,
                  }}
                >
                  <ManageAccountsIcon />
                </Box>
                Role Management
              </Button>
              <Button
                component={Link}
                to="/add-accounts"
                className="w-full text-left px-3"
                sx={{
                  color: "#EEEEEE",
                  justifyContent: "flex-start",
                  fontSize: "0.9rem",
                  padding: "10px",
                  "&:hover": {
                    backgroundColor: "#393E46",
                    color: "#EEEEEE",
                  },
                  "&:hover .icon": {
                    color: "#EEEEEE",
                  },
                  fontFamily: "Poppins",
                }}
              >
                <Box
                  className="icon"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "#00ADB5",
                    marginRight: 1,
                  }}
                >
                  <PersonAddAlt1Icon />
                </Box>
                Account Management
              </Button>
            </>
          )}
          <Divider sx={{ width: "80%", my: 2, backgroundColor: "#00ADB5" }} />{" "}
        </Box>

        <Box className="flex justify-start items-center px-4 pb-4">
          <IconButton
            onClick={handleMenuOpen}
            color="inherit"
            sx={{ fontSize: "0.8rem" }}
          >
            <Typography
              variant="body1"
              sx={{ color: "#EEEEEE", fontFamily: "Poppins" }}
            >
              <AccountCircleIcon />
              {`   ${name}`}
            </Typography>
          </IconButton>

          <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
            <Box sx={{ padding: 1 }}>
              <Typography
                variant="body1"
                sx={{ color: "#5f5f5f", fontFamily: "Poppins" }}
              >
                {" "}
                Logged in as {name}
              </Typography>
            </Box>
            <MenuItem onClick={handleLogout}>
              <Typography
                variant="body1"
                sx={{
                  fontWeight: "bold",
                  color: "#C62E2E",
                  fontFamily: "Poppins",
                }}
              >
                {" "}
                Logout
              </Typography>
            </MenuItem>
          </Menu>
        </Box>
      </Drawer>
    </>
  );
}
